import { defineComponent } from '@nuxtjs/composition-api';

// wraps head so useMeta() works with <script setup> (usePage() calls it too)
const __default__ = defineComponent({ head: {} });

import { useContext, useFetch } from '@nuxtjs/composition-api';
import { usePage, usePagePreloader } from '~/composables';


export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'index',
  setup(__props) {

const useMainPage = () => {
  const { i18n } = useContext();
  const { page, fetchPage } = usePage();
  const pagePreloader = usePagePreloader();

  useFetch(async () => {
    pagePreloader.start();
    await fetchPage('main', {
      lang: i18n.locale,
    });
    pagePreloader.stop();
  });

  return { page };
};

const { page } = useMainPage();

return { __sfc: true,useMainPage, page }
}

})